type PresignedPostData = {
  url: string;
  fields: Record<string, string>;
};

export async function uploadToPresignedUrl(
  presigned: PresignedPostData,
  blob: Blob,
  contentType = "image/jpeg",
): Promise<void> {
  const formData = new FormData();
  Object.entries(presigned.fields).forEach(([k, v]) => formData.append(k, v));
  formData.append("Content-Type", contentType);
  formData.append("file", blob, "upload");

  const res = await fetch(presigned.url, { method: "POST", body: formData });
  if (!res.ok) throw new Error(`S3 upload failed: ${res.status}`);
}
